import '@babel/polyfill';
import './modules/jqueryGlobal';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import 'bootstrap';
import './modules/slickCarousel';
import './modules/responsiveVideos';
import './modules/onPageEditingFlag';
import './modules/episerverForms/hiddenRandomNumberElementBlock';
import './modules/ajaxInitialization';
import './modules/responsiveTables';
import './modules/mobileMenu';
import './modules/bsCustomFileInputs';
import './modules/tabsListNav';
import './modules/backToTop';
import './modules/hyperlinksClass';
